export const interests = [
  "Рестораны","Юмор","Цветы","Спорткары","Кино"
];